module.exports = __webpack_public_path__ + "static/media/manager-screen.86ec6334.png";